import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'ForgotPassword',
            args: {
                form_submitted: 1,
                email: payload.email,
            },
        });

        return {
            errors: result.error,
            success: result.success,
        };
    };
};
